<template>
  <div class="p-3">
    <!-- ต้องบอกให้ชัดว่ายังไม่มีการบันทึกอะไรเกิดขึ้น ไม่งั้นผู้บริจาคจะเข้าใจว่ากดบริจาคไปแล้ว
         แล้วไปชำระเงินเข้ารายการที่ไม่มีอยู่จริง -->
    <div v-if="stepOneLost" class="alert alert-warning" role="alert">
      <div class="fw-bold">ข้อมูลผู้บริจาคหมดอายุแล้ว</div>
      <div class="small">
        ระบบยังไม่ได้บันทึกรายการบริจาคนี้ และยังไม่มี QR Code สำหรับชำระเงิน
        กรุณากรอกข้อมูลผู้บริจาคใหม่อีกครั้ง
      </div>
      <button class="btn btn-warning btn-sm mt-2" @click.prevent="backToStepOne">
        กรอกข้อมูลใหม่
      </button>
    </div>
    <div id="donatetype">
      <div class="bg-white border rounded p-4 mb-3" v-if="donateOwnerID != 0">
        <span class="fs-4">บริจาคให้{{ donateOwnerName }}</span>
      </div>
      <div class="bg-white border rounded p-4 mb-3" v-else>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="donateType"
            :disabled="disabledDonateType"
            id="forUniveresity"
            :value="false"
            v-model="isSpecific"
            @change="resetData"
          />
          <label class="form-check-label" for="forUniveresity">บริจาคให้มหาวิทยาลัย</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="donateType"
            :disabled="disabledDonateType"
            :value="true"
            id="forSpecific"
            v-model="isSpecific"
          />
          <label class="form-check-label" for="forSpecific">บริจาคแบบเจาะจง</label>
        </div>
        <div v-if="isSpecific" class="mt-4">
          <div class="ps-5">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="isDepartment"
                :value="false"
                id="forStudent"
                v-model="isDepartment"
                @change="resetData"
              />
              <label for="forStudent" class="form-label">บริจาคให้นิสิต</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="isDepartment"
                :value="true"
                id="forDepartment"
                v-model="isDepartment"
                @change="resetData"
              />
              <label for="forDepartment" class="form-label">บริจาคให้หน่วยงาน</label>
            </div>
            <div v-if="!isDepartment">
              <Vueselect
                id="studentcode"
                :options="students"
                :filterable="false"
                v-model="studentInfo"
                placeholder="รหัสหรือชื่อนิสิต"
                @search="onStudentSearch"
              >
                <template #no-options="{ search }">
                  {{ search.trim().length < 3 ? 'พิมพ์อย่างน้อย 3 ตัวอักษร' : 'ไม่พบข้อมูลนิสิต' }}
                </template>
                <template #option="{ STUDENTCODE, FIRSTNAME, SURNAME, FACULTY }">
                  {{ STUDENTCODE }} - {{ FIRSTNAME }} {{ SURNAME }} ({{ FACULTY }})
                </template>
                <template #selected-option="{ STUDENTCODE, FIRSTNAME, SURNAME }">
                  {{ STUDENTCODE }} - {{ FIRSTNAME }} {{ SURNAME }}
                </template>
              </Vueselect>
            </div>
            <div v-else>
              <Vueselect
                id="department"
                name="department"
                :options="options"
                label="NAME"
                v-model="selected"
              ></Vueselect>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="donate-method-section">
      <h4 class="text-success">เลือกช่องทางบริจาค</h4>
      <div class="accordion accordion-flush" id="accordionPaymentMethod">
        <div class="accordion-item">
          <h2 class="accordion-header" id="flush-headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTwo"
              aria-expanded="false"
              aria-controls="flush-collapseTwo"
            >
              <div class="row">
                <div class="col-auto">
                  <img src="@/assets/images/e_donation1.jpg" class="" />
                </div>
                <div class="col-9">
                  <span class="fs-4 ps-3">e-Donation</span>
                  <br />
                  <span class="text-danger fs-4 ps-3"
                    >ผู้บริจาคต้องเป็นบุคคลเดียวกันกับเจ้าของบัญชีธนาคารเท่านั้นและข้อมูลการบริจาคจะส่งไปยังกรมสรรพากร</span
                  >
                </div>
              </div>
            </button>
          </h2>
          <div
            id="flush-collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingTwo"
            data-bs-parent="#accordionPaymentMethod"
          >
            <div class="accordion-body">
              <div class="row">
                <div class="col-md-6 p-2">
                  ช่องทางบริจาคอิเล็กทรอนิกส์ที่สามารถสแกน QR-Code ได้ทุกธนาคาร
                  <span class=""
                    >ช่องทางนี้ท่านต้อง Upload Slip
                    หลักฐานการโอนด้วยและต้องบริจาคตามยอดให้ตรงกับที่ท่านระบุไว้</span
                  >
                  <br />
                </div>

                <div class="col-md-6">
                  <div class="form-floating mb-3">
                    <input
                      required
                      type="number"
                      min="1"
                      max="9999999"
                      maxlength="7"
                      class="spec-donate-amount form-control"
                      id="edonation"
                      autocomplete="off"
                      v-model="state.edonatedAmount"
                      @input="convertNumberToWords"
                    />
                    <label for="edonation">ระบุจำนวนเงิน</label>
                    <span class="numberToWord">{{ numberToWord }} </span>
                    <span v-if="v$.edonatedAmount.$error" class="require-txt">
                      {{ v$.edonatedAmount.$errors[0].$message }}
                    </span>
                  </div>
                  <div class="d-flex flex-row-reverse">
                    <button
                      class="btn btn-outline-success btn-lg"
                      @click.prevent="donate('edonate')"
                    >
                      บริจาค
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="flush-headingOne">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
              <div class="row">
                <div class="col-2">
                  <img src="@/assets/images/prompt-pay-logo.png" class="" />
                </div>
                <div class="col-auto ps-5">
                  <span class="fs-4 ps-3">THAI QR Promt Pay</span>
                  <br />
                  <span class="fs-4 ps-3 text-danger"
                    >สำหรับบริจาคในนามบุคคล นิติบุคคลหรือบุคคลอื่น
                    จะออกใบเสร็จตามข้อมูลที่ให้ใว้ข้างต้น</span
                  >
                </div>
              </div>
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionPaymentMethod"
          >
            <div class="accordion-body">
              <div class="row">
                <div class="col-md-6">
                  <span class=""
                    >ชำระผ่าน QR Code หรือ Promt Pay ได้ทุกธนาคาร ช่องทางที่สามารถสแกน QR-Code
                    แบบปรับตามยอดการบริจาค ลดความผิดพลาด สะดวก รวดเร็ว ไม่มีขั้นต่ำ
                    ไม่คิดค่าธรรมเนียม</span
                  >
                </div>
                <div class="col-md-6">
                  <div class="form-floating mb-3">
                    <input
                      type="number"
                      min="1"
                      max="9999999"
                      maxlength="7"
                      class="spec-donate-amount form-control"
                      id="regularaccount"
                      autocomplete="off"
                      v-model="state.regularAmount"
                      @input="convertNumberToWords"
                    />
                    <label for="regularaccount">ระบุจำนวนเงิน</label>
                    <span v-if="v$.regularAmount.$error" class="require-txt">
                      {{ v$.regularAmount.$errors[0].$message }}
                    </span>
                    <span class="numberToWord">{{ numberToWord }} </span>
                  </div>
                  <div class="d-flex flex-row-reverse">
                    <button
                      class="btn btn-outline-success btn-lg"
                      @click.prevent="donate('regular')"
                    >
                      บริจาค
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RepeatIntentModal
      :action="repeatIntent.action"
      :amount="repeatIntent.amount"
      :donated-at="repeatIntent.donatedAt"
      @attach-slip="onAttachSlip"
      @donate-again="onDonateAgain"
      @dismiss="closeRepeatIntent"
    />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import useVuelidate from '@vuelidate/core'
import { minValue, requiredIf } from '@vuelidate/validators'
import Vueselect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import THBText from 'thai-baht-text'
import { useCampaigns } from './scripts/useCampaigns'
import { useDepartments } from './scripts/useDepartments'
import { useStudentInfo } from './scripts/useStudentInfo'
import { useDonateInfoCookie } from './scripts/useDonateInfoCookie'
import { useRepeatIntent } from './scripts/useRepeatIntent'
import RepeatIntentModal from './RepeatIntentModal.vue'

const props = defineProps({
  campaignID: {
    type: Number,
    required: true
  }
})

// StartDonate.vue เป็นคนถือ stepActive อยู่แล้ว การพากลับ step 1 จึงใช้ทางเดิมของมัน
const emit = defineEmits(['gotoStep'])

// ข้อมูล step 1 หายไปจากคุกกี้ระหว่างที่ผู้บริจาคอยู่หน้านี้ — กรอกใหม่อย่างเดียว
const stepOneLost = ref(false)

const backToStepOne = () => {
  stepOneLost.value = false
  emit('gotoStep', 1)
}

const router = useRouter()

const { Campaigns } = useCampaigns()
const { options } = useDepartments()
const { studentInfo, students, searchStudents } = useStudentInfo()
const { setDonateInfoCookie, getDonateInfoCookie } = useDonateInfoCookie()
const { checkRepeatIntent } = useRepeatIntent()

const disabledDonateType = ref(false)
const isSpecific = ref(false)
const isDepartment = ref(false)
const selected = ref(null)
const donateOwnerID = ref('')
const donateOwnerName = ref('')
const numberToWord = ref('')
const currentMethod = ref('')

const state = reactive({
  regularAmount: '',
  edonatedAmount: '',
  amount: '',
  studentcode: '',
  dapartmentID: '',
  bankType: 1,
  donateTo: ''
})

const rules = {
  regularAmount: {
    required: requiredIf(() => currentMethod.value === 'regular'),
    minValue: minValue(1)
  },
  edonatedAmount: {
    required: requiredIf(() => currentMethod.value === 'edonate'),
    minValue: minValue(1)
  }
}

const v$ = useVuelidate(rules, state)

const resetData = () => {
  if (!isSpecific.value) {
    studentInfo.value = null
  }
  if (isDepartment.value) {
    studentInfo.value = null
    state.studentcode = ''
  } else {
    selected.value = options.value[0]
  }
}

const convertNumberToWords = (e) => {
  if (e.target.value.length !== 0) {
    numberToWord.value = THBText(e.target.value)
  } else {
    numberToWord.value = ''
  }
}

// Repeat Intent Check ทำงานตรงนี้ คือ "ก่อน" router.push('/donate') โดยเจตนา
// เพราะ DonatePage เขียนฐานข้อมูลตั้งแต่ตอน mount — ถ้าถามที่หน้านั้น INSERT จะลงไปก่อน
// โมดัลขึ้น แล้วคนที่เลือก "แนบสลิปรายการเดิม" จะทิ้งแถว Pending ขยะไว้ทุกครั้ง
// เท่ากับฟีเจอร์ที่สร้างมาแก้แถวซ้ำ กลายเป็นตัวผลิตแถวซ้ำเสียเอง
const repeatIntent = ref({ action: 'none', amount: 0, donatedAt: '', donateid: null })
// donateInfo ที่ประกอบเสร็จแล้ว พักไว้ระหว่างรอผู้บริจาคตอบโมดัล
let pendingDonateInfo = null

const closeRepeatIntent = () => {
  repeatIntent.value = { action: 'none', amount: 0, donatedAt: '', donateid: null }
}

// ไปหน้า /donate ในโหมดแนบสลิปย้อนหลัง: ไม่ INSERT ไม่สร้าง QR ใช้ donateid ของแถวเดิม
const onAttachSlip = () => {
  setDonateInfoCookie({
    ...pendingDonateInfo,
    repeat: {
      mode: 'attach_slip',
      donateid: repeatIntent.value.donateid,
      donatedAt: repeatIntent.value.donatedAt,
      shownAction: repeatIntent.value.action
    }
  })
  closeRepeatIntent()
  router.push('/donate')
}

// ผู้บริจาคเห็นคำเตือนแล้วยืนยันว่าจะให้อีกครั้ง — ต้องได้ Donation ใหม่เสมอ ไม่มีเงื่อนไขห้าม
// previousDonateid/shownAction ถูกส่งต่อไป backend เพื่อ log ว่าแถวนี้เกิดจากเจตนา ไม่ใช่ Ghost Row
const onDonateAgain = () => {
  setDonateInfoCookie({
    ...pendingDonateInfo,
    repeat: {
      mode: 'new',
      previousDonateid: repeatIntent.value.donateid,
      shownAction: repeatIntent.value.action
    }
  })
  closeRepeatIntent()
  router.push('/donate')
}

const donate = async (method) => {
  currentMethod.value = method
  const result = await v$.value.$validate()
  if (result) {
    state.amount = method === 'regular' ? state.regularAmount : state.edonatedAmount
    const dataStepOne = getDonateInfoCookie()

    // คุกกี้ donate_info อายุ 30 นาที นับตั้งแต่กด "ถัดไป" ที่ step 1 ผู้บริจาคที่ค้างอยู่
    // หน้านี้นานกว่านั้น (สลับแอปแล้ว iOS พักหน้าเว็บไว้ เกิดบ่อยในเบราว์เซอร์ในแอป LINE)
    // จะได้ null กลับมา เดิม {...null, ...stepTwo} ให้คุกกี้ที่มีแต่ step2 โดยไม่ throw
    // ข้อมูลผู้บริจาคหายถาวรเงียบๆ แล้วหน้า /donate ส่ง personal_id=undefined ไปจน POST
    // /donate ตอบ 400 ไม่มีแถวเกิดขึ้น — แต่ผู้บริจาคยังจ่ายเงินได้ เกิดขึ้นแล้ว 15 ส.ค. 2026
    if (!dataStepOne?.step1?.personal_id) {
      stepOneLost.value = true
      return
    }

    if (isSpecific.value) {
      state.donateTypeID = 1
    } else {
      state.donateTypeID = 2
    }

    if (isDepartment.value) {
      state.donateTo = `${selected.value.ID}|${selected.value.NAME}`
      state.bankType = selected.value.CAMPUSID
    } else {
      if (studentInfo.value) {
        state.bankType = studentInfo.value.CAMPUSID
        state.donateTo = `${studentInfo.value.STUDENTCODE}|${studentInfo.value.FIRSTNAME} ${studentInfo.value.SURNAME}`
      }
    }

    state.bankType = method === 'edonate' ? 3 : state.bankType || 1
    state.amount = state.amount == '' ? 0 : state.amount
    state.paymentMethod = method === 'regular' ? 2 : 1

    const stepTwo = {
      step2: state
    }

    const donateInfo = {
      ...dataStepOne,
      ...stepTwo
    }

    pendingDonateInfo = donateInfo

    const found = await checkRepeatIntent({
      personalId: dataStepOne?.step1?.personal_id,
      amount: state.amount,
      campaignID: dataStepOne?.step1?.campaignID
    })

    // ทุกเส้นทางที่ล้มเหลวของ checkRepeatIntent คืน 'none' อยู่แล้ว การบริจาคจึงไม่มีทาง
    // ถูกบล็อกเพราะ query เสริม — เจตนาตาม ADR 0002
    if (found.action !== 'none') {
      repeatIntent.value = {
        action: found.action,
        amount: found.amount,
        donatedAt: found.donatedAt,
        donateid: found.donateid
      }
      return
    }

    setDonateInfoCookie(donateInfo)
    router.push('/donate')
  }
}

const checkDonatedOwner = () => {
  const campaign = Campaigns.value.find((c) => c.ID === props.campaignID)
  if (campaign) {
    donateOwnerID.value = campaign.DONATE_OWNER
    if (donateOwnerID.value) {
      disabledDonateType.value = true
      const department = options.value.find((d) => d.ID === donateOwnerID.value)
      if (department) {
        donateOwnerName.value = department.NAME
      }
    }
  }
}

let searchTimer
const onStudentSearch = (search, loading) => {
  clearTimeout(searchTimer)
  if (search.trim().length < 3) return
  loading(true)
  searchTimer = setTimeout(async () => {
    await searchStudents(search)
    loading(false)
  }, 300)
}

onMounted(() => {
  window.scrollTo(0, 0)
  const cookieData = getDonateInfoCookie()
  if (cookieData && cookieData.step2) {
    // You can populate the state from cookies here if needed
  }
  checkDonatedOwner()
})
</script>

<style scoped>
.numberToWord {
  font-size: 0.8rem;
  color: #9e67f1;
}
.studentinfo {
  color: #555963cc;
}
.require-txt {
  color: #f30808;
}
</style>
